export default function camelize(_text: string) {
	if (_text.trim() === '') {
		return '';
	}
	const parts = _text.split(' ');
	return parts
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join('');
}
